import apiResponse from '@stores/ApiResponse';
import { QuestionnaireAdminStore, QuestionnaireTimepointDefinition } from '@stores/QuestionnaireAdminStore';
import actionResponse, { ActionResponse } from '@actions/ActionResponse';
import { questionnaireActionError } from './questionnaireActionError';

/** Adds a shared timepoint label such as MIDPOINT. The result is the new timepoint's { id }. */
export class CreateQuestionnaireTimepointAction {
  constructor(private readonly store: QuestionnaireAdminStore = new QuestionnaireAdminStore()) {}

  public async Execute(definition: QuestionnaireTimepointDefinition): Promise<ActionResponse> {
    try {
      const created = await apiResponse.handleApiResponse(() =>
        this.store.CreateTimepoint({ code: definition.code.trim(), name: definition.name.trim() })
      );
      return actionResponse.Success('Timepoint added', created);
    } catch (err) {
      return questionnaireActionError(err);
    }
  }
}
